//直播设定
const routers = [
  //绑定验证码
  {
    path: '/live-setting',
    name: 'LiveSetting',
    component: () =>
      import(/* webpackChunkName: "player" */ './views/live-setting/index.vue')
  }
];

export default routers;
